<template>
  <div>
    <el-row>
      <el-col>
        <el-button type="primary" size="medium" style="margin-top: 20px" @click="addCheckout">新增校验项</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="newTableData" style="margin-top: 20px">
          <el-table-column label="序号" type="index" width="400" min-width="100"></el-table-column>
          <el-table-column label="资质名称" prop="QUALIFICATION_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-col :span="24" style="text-align: right">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
    </el-col>
    <!-- 新增资质项 -->
    <el-dialog :visible.sync="addAptitudeDialog" @close="addAptitudeDialog = false" title="新增资质项" width="400px" center>
      <el-form ref="addAptitudeForm" :model="addAptitudeForm.qualificationList" size="small" :label-width="'100px'" :inline="true">
        <el-form-item label="资质名称:">
          <el-select filterable v-model="addAptitudeForm.qualificationList" placeholder="请选择">
            <el-option v-for="item in aptitudeList" :key="item.QUALIFICATION_ID" :label="item.QUALIFICATION_NAME"
              :value="item.QUALIFICATION_ID"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button class="operate-btn" @click="addAptitudeDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleAddAptitude">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      pageSize: 10, // 每页展示条数
      totalCount: 0, // 总条数
      currentPage: 1, // 当前页数
      newTableData: [],
      aptitudeList: [],
      addAptitudeForm: {
        qualificationList: '',
      },
      addAptitudeDialog: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    // this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT'))
    //   ? Number(localStorage.getItem('SMP_PAGE_COUNT'))
    //   : 10;
    this.queryTable();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryTable();
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 15,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result;
          this.newTableData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
          this.totalCount = this.tableData.length;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
        }
      });
    },
    // 新增资质项按钮
    getAptitude() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 16,
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.aptitudeList = result;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      });
    },
    addCheckout() {
      this.getAptitude();
      this.addAptitudeDialog = true;
    },
    // 提交新增资质项
    handleAddAptitude() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 17,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.addAptitudeForm.qualificationList) {
        params.QUALIFICATION_ID = this.addAptitudeForm.qualificationList;
      } else {
        this.$message.show({ text: '请选择资质', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addAptitudeDialog = false;
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 删除资质项
    del(row) {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 18,
        QUALIFICATION_RECORD_ID: row.QUALIFICATION_RECORD_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/qualificationItemManagement.vue